import axios from 'axios';

class APIGeneralService {
  postAnalytics(token, data, apiKey, path) {
    const auth = {
      headers: {
        Authorization: token,
        'x-api-key': apiKey,
        'Content-Type': 'application/json',
      },
    };
    return axios.post(path, data, auth);
  }
}
export default new APIGeneralService;
